import MarkdownText from '@/components/patterns/MarkdownText.jsx';
import ExecutionStatus from '@/components/surfaces/ExecutionStatus.jsx';

/** The steps one run took, each with its outcome, then the result the run reached once it has finished. */
const RunStepList = ({ steps, result, loading, isLive }) => {
  if (loading) {
    return <p className="automations-run__note">Loading what this run did...</p>;
  }

  return (
    <div className="automations-run__body">
      {steps.length > 0 ? (
        <ol className="automations-run__steps">
          {steps.map((step) => (
            <li key={step.id} className="automations-run__step">
              <span className="automations-run__step-label">{step.label}</span>
              <ExecutionStatus state={step.state} size="sm" detail={step.note || undefined} />
              {step.error && <p className="automations-run__step-error">{step.error}</p>}
            </li>
          ))}
        </ol>
      ) : (
        <p className="automations-run__note">No steps recorded for this run.</p>
      )}
      {result && !isLive && (
        <div className="automations-run__result">
          <h4 className="automations-run__result-title">Result</h4>
          <div className="automations-run__result-text">
            <MarkdownText text={result} />
          </div>
        </div>
      )}
    </div>
  );
};

export default RunStepList;
